import {
  Autocomplete,
  Box,
  Button,
  Divider,
  Stack,
  TextField,
  Typography,
  Zoom,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { DataContext } from "../InitHrm";
import axios from "axios";
import { BaseHrmUrl } from "../../Intro/Constants";

function Allocation(props) {
  const stageChanger = props.stageChanger;
  const person  = props.person;
  let placementData = {}


  const context = useContext(DataContext)

  const [companies, setCompany] = useState([]);
  const [myData, setData] = useState(null);
  const [allData, setAllData] = useState(null);
  const [departments, setDepartments]= useState(null)
  const [branches, setBranches] = useState(null);
  const [sections,setSections] = useState(null);
  const [selectedSection,setSelectedSection] = useState(null);
  const [selectedCompany,setSelectedCompany] = useState(null);
  const [selectedBranch,setSelectedBranch] = useState(null);
  const [allSelectedSections,setAllSelectedSections] = useState(null);


  const handleSubmit = ()=>{
    const selected = allSelectedSections.filter(sect=>{
      if(sect.section !==selectedSection){
        return false
      }
      return true
     });
     async function loadData() {
      try {
        const response = await axios.post(`${BaseHrmUrl}/allocate`,
          { section_id: selected[0].id, username: person.user.username },
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
       
      
      if (response.status === 200) {
        alert('Allocation was successful')
      }
      else{alert('Failed to allocate')}
    
      } catch (error) {
        alert('Internal server error');
      }
    };
  loadData()
  } 
  


  const handleDeptClick = (dept) => {
    placementData.department = dept
    const allSections = allData.filter((data) => {
      if (data.department.department !== dept) {
        return false;
      } else {
        return true;
      }
    });
    setAllSelectedSections(allSections)
    const selectedSections = allSections.map(brn=>{
      return brn.section
    });
    

    setSections(selectedSections);
  };



  const handleBranchClick = (branch) => {
    setSelectedBranch(branch)
  };

  useEffect(()=>{
    if(!allData){return}
    const allDepartments = allData.filter((data) => {
      if (data.department.branch.branch_name !== selectedBranch) {
        return false;
      } else {
        return true;
      }
    });
    const selectedDeps = allDepartments.map(brn=>{
      return brn.department.department
    });
    setDepartments(Array.from(new Set(selectedDeps)));
  },[allData])

//filter companies
  useEffect(()=>{
    if(myData){
      const all_companies = myData.map(datum=>{
        return datum.company.company_name
      });
      const no_repet = new Set(all_companies)
      setCompany(Array.from(no_repet));
   
    }

  },[myData])

  
//load sections
  useEffect(() => {
    if(!selectedCompany || !selectedBranch){
      return
    }
    async function loadData() {
      try {
        const response = await axios.post(`${BaseHrmUrl}/section`,
          { key: context.token, company:selectedCompany, branch:selectedBranch },
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
       
      
        if (response.status === 200) {
          setAllData(response.data);
        }
    
      } catch (error) {
        alert('Internal server error');
      }
    };
    loadData()
  
    
  }, [selectedCompany,selectedBranch]);


  useEffect(() => {
    async function loadData() {
      try {
        const response = await axios.get(`${BaseHrmUrl}/branches`);
       
      
        if (response.status === 200) {
          setData(response.data);
        }
      
    
      } catch (error) {
        alert('Internal server error');
      }
    };
  loadData() 
  }, []);

  const handleCompanyChange=(val)=>{
    setSelectedCompany(val)
    const branchlist = myData.filter(dat=>{
      if(dat.company.company_name===val){
        return true
      }else{
        return false
      }
    });
    const required_branches = branchlist.map(branch=>{
      return branch.branch_name
    });
    setBranches(required_branches)
  }

  return (
    <>
      <Zoom in={true} style={{ transitionDelay: "200ms" }}>
        <Stack>
          <Typography variant="h6">Placement</Typography>
          <Divider variant="middle" />
          <Stack mt={3}>
            <Box display={'flex'} columnGap={2}>
              <Autocomplete
                disablePortal
                options={companies}
                sx={{ width: 300 }}
                onChange={(e,val)=>handleCompanyChange(val)}
                renderInput={(params) => (
                  <TextField {...params} label="Company" size="small" />
                )}
              />
              <Autocomplete
            disablePortal
            options={branches}
            onChange={(e,val)=>handleBranchClick(val)}
            sx={{ width: 300 }}
            renderInput={(params) => <TextField {...params} label="Branch" size="small"/>}
            />

              <Autocomplete
                disablePortal
                options={departments}
                onChange={(e,val)=>handleDeptClick(val)}
                sx={{ width: 300 }}
                renderInput={(params) => (
                  <TextField {...params} label="Department" size="small" />
                )}
              />

              <Autocomplete
                disablePortal
                options={sections}
                sx={{ width: 300 }}
                onChange={(e,val)=>setSelectedSection(val)}
                renderInput={(params) => (
                  <TextField {...params} label="Section" size="small" />
                )}
              />
            </Box>
            <Box display={'flex'} columnGap={2} mt={3}>
                <Button variant="outlined" sx={{borderRadius:4}}>new client</Button>
                <Button variant="outlined" sx={{borderRadius:4}}>add town</Button>
            </Box>
            <Box display={'flex'} columnGap={2} mt={3}>
                <Button size='small' sx={{borderRadius:4}} variant="contained" onClick={handleSubmit}>
                    submit
                </Button>
            </Box>
          </Stack>
        </Stack>
      </Zoom>
    </>
  );
}

export default Allocation;
